import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { resetInformation } from "../../store/reducers/user/userReducer";
import { removeCookie } from "../../utils/CookiesUtil";
import { setIsAuth } from "../../store/reducers/auth/authReducer";
import { ROUTES_CONSTANTS } from "../../constants/routesConstants";


const useLogout = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    removeCookie('accessToken');
    dispatch(resetInformation());
    dispatch(setIsAuth(false));
    navigate(ROUTES_CONSTANTS.LOGIN);
  };

  return [logout];

};

export default useLogout;